import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import translations_en from "./lang/english/translations.json";
import translations_sinhala from "./lang/sinhala/translations.json";
import translations_tamil from "./lang/tamil/translations.json";

const resources = {
  en: {
    translation: translations_en,
  },
  si: {
    translation: translations_sinhala,
  },
  ta: {
    translation: translations_tamil,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en",

  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
